export default "__VITE_ASSET__TnjWr1JT__"